import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import RightMark from '../../svg/icons/RightMark.svg';
import './CardAdded.scss';
import TranslationProvider from '../../providers/TranslationProvider';

const CardAdded = (props) => {
  const { eventData, Analytics } = props;

  useEffect(() => {
    Analytics.event('interact with gating modal', eventData);
  }, []);

  return (
    <div className="CardAdded">
      <div className="CardAdded-header">
        <TranslationProvider translationKey="card_added_header">
          <div className="CardAdded-text">Card added</div>
        </TranslationProvider>
        <RightMark data-testid="RightMark" />
      </div>
      <div className="CardAdded-message">
        <div>
          <TranslationProvider translationKey="card_added_wait_message">
            <span>
              It may take a few moments to add your Card information.
              Please try refreshing the page shortly.
            </span>
          </TranslationProvider>
        </div>
        <div>
          <TranslationProvider translationKey="support_message">
            <span>
              Still experiencing issues or have any questions? Please reach out to
              our customer support team at&nbsp;
            </span>
          </TranslationProvider>
          <a className="CardAdded-mail" target="_blank" rel="noreferrer" href="mailto:help@resy.com">help@resy.com</a>
          <span>.</span>
        </div>
      </div>
    </div>
  );
};

CardAdded.propTypes = {
  eventData: PropTypes.shape({
    venue: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    platform: PropTypes.string.isRequired,
    action: PropTypes.string.isRequired,
    eventAsset: PropTypes.string.isRequired,
  }).isRequired,
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
};

export default CardAdded;
